import React, { FC, useContext } from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { Link } from "react-router-dom";
import BtnLikeIcon from "components/BtnLikeIcon/BtnLikeIcon";
import { useLocation } from "react-router-dom";
import email from "../../images/email.svg";
import phone from "../../images/phone.svg";

import { AuthContext } from "context/userContext";
import axios from "axios";
import { API_URL } from "api/config";

export interface StayCardProps {
  key?: any;
  currentProperty?: any;
  data: any;
  size?: any;
  className?: any;
  formikValues?:any
}

const StayCard2: FC<StayCardProps> = ({ data, size, className, formikValues }) => {
  const {
    _id,
    type,
    title,
    price,
    cover_image,
    galleryImgs,
    category,
    viewsCount,
    Address
  } = formikValues;
const location = useLocation();

  const isDirecConnectPage = location.pathname === "/account-direktConnects";
  const isAddpropPage = location.pathname === "/add-property";
  const authContext = useContext(AuthContext);
  // const dataFavourite = authContext.favPropData;
  // const addtoSavedList = authContext.addtoSavedList;
  // const delFromSavedList = authContext.delFromSavedList;
  // const hostData = authContext.hostData;
  const addressArray = typeof Address === "string" && Address.trim()
  ? Address.split(",")
      .map((item: any) => item.trim().replace(/\b\d{6}\b/, "").trim())
      .filter((part: any) => part)
  : [];
  const renderSliderGallery = () => {
    const combinedArray = [cover_image || "", ...(galleryImgs || [])];
    return (
      <div className="relative w-full">
        <GallerySlider
          uniqueID={`StayCard_${_id}`}
          ratioClass="aspect-w-4 aspect-h-3 "
          galleryImgs={combinedArray}
          href={`/detail?propID=${_id}`}
          propertyId={_id}
        

        />
        {/* <BtnLikeIcon
          addtoSavedList={addtoSavedList}
          idd={_id}
          dataFavourite={dataFavourite}
          delFromSavedList={delFromSavedList}
          className="absolute right-3 top-3 z-[1]"
        /> */}
      </div>
    );
  };

  

  const renderContent = () => {
    return (
      <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
        <div className="space-y-2">
         
          <div className="flex items-center space-x-2">
            <h2
              className={` font-medium capitalize ${
                size === "default" ? "lg:text-lg" : "text-base"
              }`}
            >
              <span className="line-clamp-1 text-base">{title}</span>
            </h2>
          </div>
          <span className="lg:text-xs text-xs text-neutral-500 dark:text-neutral-400 w-full block text-truncate text-nowrap">
            {category}<span style={{ margin: "0 5px", fontWeight: "bold" }}>•</span>
            {type}<span style={{ margin: "0 5px", fontWeight: "bold" }}>•</span>
            {addressArray?.slice(-3, -2).join(",")}
          </span>
          {/* <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
            {size === "default" && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 flex-shrink-0"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            )}
            <span className="line-clamp-1">{address}</span>
          </div> */}
        </div>
        {/* <div className="w-14 border-b border-neutral-100 dark:border-neutral-800"></div> */}
        {!isDirecConnectPage ? (
              <div className="flex justify-between items-center">
              <span
                className="text-base font-semibold"
                style={{ fontFamily: "Roboto" }}
              >
                {Number(price).toLocaleString("en-IN", {
                  style: "currency",
                  currency: "INR",
                  minimumFractionDigits: 0,
                })}
                {size === "default" && (
                  <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                    /night
                  </span>
                )}
              </span>
              {/* {!!count && <StartRating reviewCount={count} point={avgRating} />} */}
            </div>
        ) : (
          <div className="details flex justify-between flex-1 items-center">
          <div className="">
            <h2 className=" text-xs  text-neutral-700 font-normal">
              Hosted by
            </h2>
            <div className="flex">
                <p className="text-xs  font-medium">
                  {data.ownerID.firstname}
                </p>
            </div>
          </div>

          
            <div className="flex flex-col justify-center items-center">
              <div className="flex justify-center items-center">
                <img src={email} alt="email" className="" />
                <p className=" text-xs  text-neutral-700 ml-1 ">
                  {data?.ownerID?.email || "N/A"}
                </p>
              </div>

              <div className="flex justify-start items-center w-full mt-1">
                <img src={phone} alt="phone" className="" />
                <p className=" text-xs  text-neutral-700 ml-1">
                  {data?.ownerID?.phoneNumber || "NA"}
                </p>
              </div>
            </div>
       
        </div>
        )}
    
      </div>
    );
  };

  return (
    <div
      className={`nc-StayCard group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden will-change-transform hover:shadow-xl transition-shadow ${className}`}
      data-nc-id="StayCard"
      // onClick={() => propertyViewsCount()}
    >
      {renderSliderGallery()}
      {isAddpropPage ? (
        <div
          style={{ cursor: "default" }}
        >
          {renderContent()}
        </div>
      ) : (
        <Link to={`/detail?propID=${_id}`}>
          {renderContent()}
        </Link>
      )}
      {/* <Link to={`/detail?propID=${_id}`}>{renderContent()}</Link> */}
    </div>
  );
};

export default StayCard2;
